import { useState, useEffect } from 'react';

export function useCountdown(expiresAt: string | undefined) {
  const [timeRemaining, setTimeRemaining] = useState<string>('');

  useEffect(() => {
    if (!expiresAt) return;

    const updateTimer = () => {
      const now = new Date();
      const expiration = new Date(expiresAt);
      const diff = expiration.getTime() - now.getTime();
      
      if (diff <= 0) {
        setTimeRemaining('Poll has ended');
        return;
      }
      
      const hours = Math.floor(diff / (1000 * 60 * 60));
      
      if (hours > 6) {
        setTimeRemaining(`Poll closes at ${expiration.toLocaleString(undefined, {
          dateStyle: 'medium',
          timeStyle: 'short'
        })}`);
        return;
      }
      
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      setTimeRemaining(`Time remaining: ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [expiresAt]);

  return timeRemaining;
}